/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFSecReviewLocale } from './CRSFSecReviewLocale';
import {
    CRSFSecReviewLocaleFromJSON,
    CRSFSecReviewLocaleFromJSONTyped,
    CRSFSecReviewLocaleToJSON,
} from './CRSFSecReviewLocale';

/**
 * 
 * @export
 * @interface CRSFSecReviewValidationScanTrigger
 */
export interface CRSFSecReviewValidationScanTrigger {
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewValidationScanTrigger
     */
    account_id?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFSecReviewValidationScanTrigger
     */
    datapoint?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CRSFSecReviewValidationScanTrigger
     */
    dry_run?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CRSFSecReviewValidationScanTrigger
     */
    force?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewValidationScanTrigger
     */
    issue?: string;
    /**
     * 
     * @type {CRSFSecReviewLocale}
     * @memberof CRSFSecReviewValidationScanTrigger
     */
    locale?: CRSFSecReviewLocale;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewValidationScanTrigger
     */
    quote_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewValidationScanTrigger
     */
    request_origin?: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewValidationScanTrigger
     */
    user?: string;
}

/**
 * Check if a given object implements the CRSFSecReviewValidationScanTrigger interface.
 */
export function instanceOfCRSFSecReviewValidationScanTrigger(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CRSFSecReviewValidationScanTriggerFromJSON(json: any): CRSFSecReviewValidationScanTrigger {
    return CRSFSecReviewValidationScanTriggerFromJSONTyped(json, false);
}

export function CRSFSecReviewValidationScanTriggerFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewValidationScanTrigger {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'account_id': !exists(json, 'account_id') ? undefined : json['account_id'],
        'datapoint': !exists(json, 'datapoint') ? undefined : json['datapoint'],
        'dry_run': !exists(json, 'dry_run') ? undefined : json['dry_run'],
        'force': !exists(json, 'force') ? undefined : json['force'],
        'issue': !exists(json, 'issue') ? undefined : json['issue'],
        'locale': !exists(json, 'locale') ? undefined : CRSFSecReviewLocaleFromJSON(json['locale']),
        'quote_id': !exists(json, 'quote_id') ? undefined : json['quote_id'],
        'request_origin': !exists(json, 'request_origin') ? undefined : json['request_origin'],
        'user': !exists(json, 'user') ? undefined : json['user'],
    };
}

export function CRSFSecReviewValidationScanTriggerToJSON(value?: CRSFSecReviewValidationScanTrigger | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'account_id': value.account_id,
        'datapoint': value.datapoint,
        'dry_run': value.dry_run,
        'force': value.force,
        'issue': value.issue,
        'locale': CRSFSecReviewLocaleToJSON(value.locale),
        'quote_id': value.quote_id,
        'request_origin': value.request_origin,
        'user': value.user,
    };
}

